// extracted by mini-css-extract-plugin
module.exports = {"details":"BankDetailsDetails_details__2k2FB"};